module.exports = __webpack_public_path__ + "static/media/whatsapp.953a8c3e.png";